import React from 'react'
import { Checkbox } from '@arnsbogroup/react-voicearchive'

const CheckBox = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute

  const onCheck = (value) => {
    onChange(options.map((option) => {
      if (option.value == value) {
        option.checked = !option.checked
      }
      return option
    }))
  }

  return (
    <fieldset className="space-y-2">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <div className="-space-y-px rounded-sm border border-gray-300 divide-y divide-gray-300">
        { options.map(({ value, label, description, checked }, i) => (
          <div key={value} className="relative p-4 flex cursor-pointer hover:bg-blue-100" onClick={() => onCheck(value)}>
            <div className="flex items-center h-5">
              <Checkbox
                name={`checkbox-${key}-${i}`}
                onChange={() => onCheck(value)}
                checked={checked}
                disabled={disabled}
              />
            </div>

            <label htmlFor={`radio-${key}-${i}`} className="ml-3 flex flex-col cursor-pointer">
              <span className={`${state == value ? 'text-primary' : 'text-gray-900'} block text-sm font-medium`}>
                { label }
              </span>
              <span className={`${state == value ? 'text-primary' : 'text-gray-500'} block text-sm`}>
                { description }
              </span>
            </label>
          </div>
        )) }
      </div>

    </fieldset>
  )
}

export default CheckBox
